<template>
	<div class="pay-success">
		<div class="wp-title">
			<span>{{ $t("Payment successfull!") }}</span>
			<span>{{ $t("We will contact you shortly.") }}</span>
		</div>
		<div class="wp-sub-title">
			<span> {{ $t("You will receive a confirmation email shortly") }}</span>
			<span> {{ $t("Below are the contact information for your course advisor Mandy") }}</span>
		</div>
		<div class="mandy">
			<wp-mandy-mini :radius="true"></wp-mandy-mini>
		</div>
	</div>
</template>

<script>
	import WpMandyMini from "../components/WpMandyMini.vue";
	export default {
		components: { WpMandyMini },
		name: "PaymentSuccessfull",
		data() {
			return {};
		}
	};
</script>


<style lang="less" scoped>
	@media screen and (min-width: @device) {
		.mandy {
			width: 421px;
		}
	}

	@media screen and (max-width: @device) {
		.mandy {
			width: 90%;
		}
	}

	.pay-success {
		margin-bottom: 30px;
	}

	.wp-title {
		margin-top: 77px;
	}

	.mandy {
		margin: auto;
	}
</style>



// WEBPACK FOOTER //
// src/views/PaymentSuccessfull.vue